import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "block text-sm" }
const _hoisted_7 = { class: "text-[18px] md:text-[20px] mb-0 mt-[4px]" }
const _hoisted_8 = { class: "relative min-h-[123px]" }
const _hoisted_9 = {
  key: 1,
  class: "flex justify-center items-center h-[99px]"
}
const _hoisted_10 = { class: "grid grid-cols-12 mt-[12px] gap-[15px]" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "block text-sm" }
const _hoisted_14 = { class: "block text-[15px] font-medium" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "block text-sm" }
const _hoisted_18 = { class: "block text-[15px] font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.directT('dashboard.totalOrders')), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["inline-block px-[8.3px] py-[1px] border text-sm ltr:ml-[10px] rtl:mr-[10px] rounded-[100px]", _ctx.percentageChange >= 0 ? 
              'text-success-700 border-success-300 bg-success-100' : 
              'text-danger-700 border-danger-300 bg-danger-100'])
          }, _toDisplayString(_ctx.percentageChange >= 0 ? '+' : '') + _toDisplayString(_ctx.percentageChange) + "% ", 3)
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.directT('dashboard.last7Days')), 1)
      ]),
      _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.loading ? '...' : _ctx.totalOrderCount), 1),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isClient && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "99",
              options: _ctx.totalOrdersChart,
              series: _ctx.orders
            }, null, 8, ["options", "series"]))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" }, null, -1)
              ])))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "inline-block w-[8px] h-[8px] ltr:mr-[10px] rtl:ml-[10px] bg-primary-500 rounded-full" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('dashboard.orders')), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.loading ? '...' : _ctx.completedOrdersCount), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "inline-block w-[8px] h-[8px] ltr:mr-[10px] rtl:ml-[10px] bg-[#00F7BF] rounded-full" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.directT('dashboard.pending')), 1),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.loading ? '...' : _ctx.pendingOrdersCount), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}